export const BETA = "DATABASE_BETA";

export const STABLE = "DATABASE_STABLE";

export const STABLE_VERSION = "3.4";

export const BETA_VERSION = "";

export const UPDATE_DATE = "May 01, 2023";
